import icons from './material-icons.json'

export const getIconsAll = () => {
  return icons
}
